export const environment = {
  production: false,
  configPath: 'assets/configs/rer-excel.config.json',
  keycloakUrl: 'https://auth.simadvisory.com/auth',
  realm: 'SPRICED_NRP',
  clientId: 'SPRICED_NRP_CLIENT',
  base_url: 'https://uat-spriced-nrp-enc.alpha.simadvisory.com',
  uploadBatchSize: 5000
};
